import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
} from "../../../../../components/styled/Elements";
import {
  CancelWithBg,
  LeftArrowBlack,
  RightArrowWhite,
  RightArrowWithoutBar,
  SearchIcon,
  UserPlaceholder,
} from "../../../../../components/styled/AllImages";
import FloatingInput from "../../../../../components/common/inputFields/FloatingInput";
import { useEffect, useState } from "react";
import NewCustomRadio from "../../../../../components/common/radioButtons/NewCustomRadio";

const SelectProductModal = ({
  show,
  onHide,
  title,
  action,
  planInfo,
  optionsList,
  onSelect,
  selectedItem,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleChange = (e) => {
    const { value } = e.target;
  };

  const [filteredOptions, setFilteredOptions] = useState(optionsList);
  const handleSearch = (e) => {
    const { value } = e.target;
    const searchQuery = value.toLowerCase();

    const updatedList = optionsList.filter((item) => {
      if (item?.name) {
        return item?.name.toLowerCase().includes(searchQuery);
      }
      return item?.subLabel?.toLowerCase().includes(searchQuery);
    });

    setFilteredOptions(updatedList);
  };

  useEffect(() => {
    if (optionsList) setFilteredOptions(optionsList);
  }, [optionsList]);

  useEffect(() => {
    // console.log(optionsList?.find((item) => item?.name == selectedItem), selectedItem);

    if (selectedItem)
      setSelectedProduct(
        optionsList?.find((item) => item?.name == selectedItem)
      );
  }, [selectedItem]);

  const onSubmit = () => {
    if (selectedProduct) {
      onSelect?.(selectedProduct); // Trigger the parent callback
      setSelectedProduct(null);
      reset();
      onHide(); // Close modal
    }
  };

  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <SelectProductModalWrapper>
        <Box className="">
          <Box className="d-flex justify-content-between align-items-center p-4">
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {title}
            </HeadingStyled>
            <CancelWithBg
              className="cursor-pointer"
              style={{ height: "33px", width: "33px" }}
              onClick={onHide}
            />
          </Box>
        </Box>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="paddingExceptTop">
            <Box className="mb-1">
              <FloatingInput
                name="search"
                type="input"
                fieldType="text"
                label={t("search")}
                placeholder={t("search")}
                icon={SearchIcon}
                onChange={handleSearch}
              />
            </Box>
            <Box className="modal-content-box">
              {filteredOptions?.map((user, index) => (
                <div key={index}>
                  <NewCustomRadio
                    padding="11px 0px"
                    name={"user"}
                    avatar={
                      user?.images
                        ? `${process.env.REACT_APP_ASSET_URL}/${user?.images}`
                        : UserPlaceholder
                    }
                    label={t(user?.name)}
                    subLabel={t(user?.position ? user.position : user.subLabel)}
                    // className={"px-4"}
                    checked={selectedProduct?.name === user?.name}
                    onChange={() => setSelectedProduct(user)}
                  />
                </div>
              ))}
            </Box>
          </Box>
          <Box className="modal-footer">
            <ButtonStyled
              border="var(--borderExtraLight)"
              iconBefore={LeftArrowBlack}
              bg="transparent"
              label={t("Cancel")}
              color="var(--text)"
              type="button"
              onClick={() => {
                onHide();
                reset();
              }}
            ></ButtonStyled>
            <ButtonStyled
              bg="var(--themeColor)"
              label={t("done")}
              type="submit"
              icon={RightArrowWhite}
              // isLoading={loading}
            ></ButtonStyled>
          </Box>
        </Form>
      </SelectProductModalWrapper>
    </Modal>
  );
};

export default SelectProductModal;

const SelectProductModalWrapper = styled.div`
  .user-item {
    border-bottom: 1px solid red;
  }

  .user-item:last-child {
    border-bottom: none;
  }

  .modal-content-box {
    max-height: 300px;
    overflow-y: auto;
  }
`;
